// extracted by mini-css-extract-plugin
export default {"columnsHeaders":"HeaderResourcesGrid_columnsHeaders__xwibO","selected":"HeaderResourcesGrid_selected__ydLDI"};